import { PageWithTitle } from 'utils/PageWithTitle'
import NotAuthorizedCard from 'components/NotAuthorizedCard/NotAuthorizedCard'

export default function NotAuthorized() {
  return (
    <PageWithTitle title="Not Authorized">
      <NotAuthorizedCard />
    </PageWithTitle>
  )
}
